module.exports = __webpack_public_path__ + "static/wanderlust-banner-c18448f2ca0171eb4e2b052f06eca8be.png";